const rarities = {
  1: 'WHITE',
  2: 'MAGIC',
  3: 'RARE',
  4: 'GEM',
  5: 'RUNE',
  6: 'RUNEWORD',
  7: 'UNIQUE',
  8: 'SET',
  9: 'MISC',
};

export const getRarityName = (rarityId) => {
  return rarities[rarityId] || 'WHITE';
};

export const getColorFromRarity = (rarityInput) => {
  // If input is a number, treat it as a rarity ID
  const rarityName =
    typeof rarityInput === 'number' ? getRarityName(rarityInput) : rarityInput?.toUpperCase();

  const textColorMap = {
    WHITE: '#FFFFFF',
    SET: '#00FF00',
    MAGIC: '#4169E1',
    UNIQUE: '#A59263',
    GEM: '#FFFFFF',
    RARE: '#FFFF00',
    NORMAL: '#FFFFFF',
    RUNEWORD: '#A59263',
    RUNE: '#A59263',
    MISC: '#FFFFFF',
  };

  return textColorMap[rarityName] || '#FFFFFF';
};
